/**
 * Shows a non-blocking full-screen overlay when the user's session is kicked.
 * Unlike window.alert(), this does NOT block other browser tabs.
 */
export const showSessionKickedOverlay = (
  message: string,
  onDismiss: () => void
): void => {
  // Prevent duplicate overlays
  if (document.getElementById("session-kicked-overlay")) return;

  const overlay = document.createElement("div");
  overlay.id = "session-kicked-overlay";
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    backdrop-filter: blur(4px);
  `;

  const card = document.createElement("div");
  card.style.cssText = `
    background: #ffffff;
    border-radius: 12px;
    padding: 32px;
    max-width: 420px;
    width: 90%;
    text-align: center;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  `;

  // Warning icon
  const iconSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  iconSvg.setAttribute("width", "48");
  iconSvg.setAttribute("height", "48");
  iconSvg.setAttribute("viewBox", "0 0 24 24");
  iconSvg.setAttribute("fill", "none");
  iconSvg.setAttribute("stroke", "#e67e22");
  iconSvg.setAttribute("stroke-width", "2");
  iconSvg.setAttribute("stroke-linecap", "round");
  iconSvg.setAttribute("stroke-linejoin", "round");
  iconSvg.innerHTML = `
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  `;
  iconSvg.style.marginBottom = "16px";

  const title = document.createElement("h2");
  title.textContent = "Session Ended";
  title.style.cssText = `
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  `;

  const msg = document.createElement("p");
  msg.textContent = message;
  msg.style.cssText = `
    margin: 0 0 24px 0;
    font-size: 14px;
    color: #666;
    line-height: 1.5;
  `;

  const button = document.createElement("button");
  button.textContent = "OK";
  button.style.cssText = `
    background: #338F86;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 10px 40px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
  `;
  button.onmouseenter = () => {
    button.style.background = "#297B72";
  };
  button.onmouseleave = () => {
    button.style.background = "#338F86";
  };
  button.onclick = () => {
    overlay.remove();
    onDismiss();
  };

  card.appendChild(iconSvg);
  card.appendChild(title);
  card.appendChild(msg);
  card.appendChild(button);
  overlay.appendChild(card);
  document.body.appendChild(overlay);
};
